<template>
  <div class="animated fadeIn liquidaciones-sueldos">
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :periodoDesde="periodoDesdeParam"
          :periodoHasta="periodoHastaParam"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Listado de Liquidaciones de Sueldos">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="liquidacionesSueldos" 
              :fields="fields" 
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(fechaRegistro)="data">
              {{ data.item.fechaRegistro | fecha }}
            </template>
            <template v-slot:cell(periodo)="data">
              <template v-if="!data.item.liquidacionFinal">
                {{ data.item.periodo | periodo }}
              </template>
              <template v-if="data.item.liquidacionFinal">
                {{ data.item.fechaLiquidacion | fecha }}
              </template>
            </template>
            <template v-slot:cell(detalle)="data">
              <template v-if="data.item.sac">
                {{ data.item.sac ? 'SAC' : '' }}
              </template>
              <template v-if="data.item.liquidacionFinal">
                {{ data.item.liquidacionFinal ? 'Liq. Final' : '' }}
              </template>
            </template>
            <template v-slot:cell(total)="data">
              {{ data.item.total | moneda }}
            </template>
            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <!-- v-if="!data.item.liquidacionFinal" -->
                <b-dropdown-item
                    @click.stop="editar(data.item)">
                  <i class="fa fa-edit"></i>Editar Liquidación</b-dropdown-item>
                <b-dropdown-item @click.stop="pago(data.item)">
                  <i class="fa fa-usd"></i>Registrar Pago</b-dropdown-item>
                <b-dropdown-item @click.stop="borrarPagos(data.item)">
                  <i class="fa fa-remove"></i>Anular Pagos</b-dropdown-item>
                <b-dropdown-item @click.stop="borrarItem(data.item)">
                  <i class="fa fa-remove"></i>Borrar Liquidación</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="agregar">
            <i class="fa fa-plus"></i>Agregar Liquidación de Sueldos</b-dropdown-item>
          <b-dropdown-item @click.stop="agregarLiquidacionFinal">
            <i class="fa fa-plus"></i>Agregar Liquidación Final</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <!-- <div class="fixed-btn">
      <div class="list-add-btn" @click.prevent="agregar">
          <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
      </div>
    </div> -->

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Filtro from './listFiltro.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import { createHelpers } from 'vuex-map-fields';
import moment from 'moment';

const { mapFields } = createHelpers({
  getterType: 'liquidacionesSueldos/getField',
  mutationType: 'liquidacionesSueldos/updateField',
});

export default {
  name: 'LiquidacionesSueldos',
  components: {
    appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal 
  ],
  data: () => {
    return {
      fields: [
        {
          key: 'fechaRegistro',
          label: 'Fecha'
        },
        {
          key: 'periodo',
        },
        {
          key: 'detalle',
          label: '',
        },
        {
          key: 'total',
          class: 'text-right'
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'liquidacionesSueldos',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'periodoDesde',
      'periodoHasta',
    ]),
    periodoDesdeParam() {
      return moment(this.periodoDesde).format('YYYY-MM-DD');
    },
    periodoHastaParam() {
      return moment(this.periodoHasta).format('YYYY-MM-DD');
    }
  },
  created() {
    this.getItems();
  },  
  methods: {
    filtrar(filtro) {
      this.periodoDesde = filtro.periodoDesde;
      this.periodoHasta = filtro.periodoHasta;
      this.paginaActual = 1;
      
      this.getItems();
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('liquidacionesSueldos/getLiquidacionesSueldos')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    agregar () {
      this.$router.push({ name: 'LiquidacionSueldosAdd' });
    },
    agregarLiquidacionFinal() {
      this.$router.push({ name: 'LiquidacionSueldosFinalAdd' });
    },
    editar (item) {
      if ((/true/i).test(item.liquidacionFinal)) {
        this.$router.push({ name: 'LiquidacionSueldosFinalEdit', 
                            params: { id: item.id }});
      } else {
        this.$router.push({ name: 'LiquidacionSueldosEdit', 
                            params: { id: item.id }});
      }
    },
    consultar (item) {
      this.$router.push({ name: 'LiquidacionSueldosData', 
                          params: { id: item.id }});
    },
    borrarItem (item) {
      this.showModalConfirm('¿Desea borrar la liquidación seleccionada?', 
            this.delete.bind(this, item.id), 'Si', null, 'No')
    },
    delete(liquidacionSueldosId) {
      this.showSpinner();
      this.$store.dispatch('liquidacionesSueldos/delete', liquidacionSueldosId)
        .then(() => this.showModalMsj('La liquidación se borró con éxito', this.getItems, this.getItems, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    pago (item) {
      this.$router.push({ name: 'LiquidacionSueldosPago', 
                          params: { liquidacionSueldosId: item.id }});
    },
    borrarPagos (item) {
      this.showModalConfirm('¿Desea anular los pagos asociados a la liquidación seleccionada?', 
            this.deletePagos.bind(this, item.id), 'Si', null, 'No')
    },
    deletePagos(liquidacionSueldosId) {
      this.showSpinner();
      this.$store.dispatch('liquidacionSueldosPagos/deletePagos', liquidacionSueldosId)
        .then(() => this.showModalMsj('Los pagos asociados a la liquidación se anularon con éxito', this.getItems, this.getItems, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
  .liquidaciones-sueldos .registro table td {
    vertical-align: middle;
    /* border: none; */
  }
  .liquidaciones-sueldos .registro table td[aria-colindex="1"] {
    width: 20%;
  }
  .liquidaciones-sueldos .registro table td[aria-colindex="2"] {
    width: 20%;
  }
  .liquidaciones-sueldos .registro table td[aria-colindex="3"] {
    width: 20%;
  }
  .liquidaciones-sueldos .registro table td[aria-colindex="4"] {
    width: calc(40% - 60px);
  }
  .liquidaciones-sueldos .registro table td[aria-colindex="5"] {
    width: 60px;
  }
</style>
